import React from 'react';
import { Box, chakra, Flex, Heading, Image } from '@chakra-ui/react';

// Import your skill images
import html from "../images/html.png";
import react from "../images/react.png";
import css from "../images/css.png";
import js from "../images/js.png";
import nodejs from "../images/node.png"
import typescript from "../images/Typescript_logo_2020.svg.png";
import chakraui from "../images/chakraui.jpeg";
import redux from "../images/redux (1).png"
import styled from "../images/styledcomponent.jpeg";
import express from "../images/express.png";
import mongoDB from "../images/mongo.png";

// Define frontend and backend skills
const frontendSkills = [
  { name: 'HTML', image: html },
  { name: 'CSS', image: css },
  { name: 'JavaScript', image: js },
  { name: 'React', image: react },
  { name: 'Redux', image: redux },
  { name: 'TypeScript', image: typescript },
  { name: 'Chakra UI', image: chakraui },
];

const backendSkills = [
  { name: 'Node.js', image: nodejs },
  { name: 'Express.js', image: express },
  { name: 'Mongo DB', image: mongoDB },
  // Add more backend skills and images as needed
];

const Skills = () => {
  return (
    <div id="skills" py={6} m="5%">
      <Box mx={"auto"} pt={5} px={{ base: 2, sm: 10, md: 17 }}>
        <chakra.h1
          textAlign={"center"}
          fontSize={"3xl"}
          py={10}
          fontWeight={"bold"}
        >
          Skills
        </chakra.h1>
        <Flex
          direction={{ base: 'column', md: 'row' }}
          align="center"
          justifyContent="center"
          flexWrap="wrap"
          gap={8}
        >
          {frontendSkills.map(skill => (
            <Box
              key={skill.name}
              boxShadow="rgba(0, 0, 0, 0.35) 0px 5px 15px"
              w={{ base: '80%', md: '125px' }}
              p={4}
              textAlign="center"
              className="skills-card"
              _hover={{
                bg: 'teal.400',
              }}
              borderRadius={"5px"}
            >
              <Image
                src={skill.image}
                alt={skill.name}
                className="skills-card-img"
                boxSize="100px"
                objectFit="contain"
              />
              <Heading as='h4' size='sm' mt={2} className="skills-card-name">
                {skill.name}
              </Heading>
            </Box>
          ))}

          {backendSkills.map(skill => (
            <Box
              key={skill.name}
              boxShadow="rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px"
              w={{ base: '80%', md: '125px' }}
              p={4}
              textAlign="center"
              _hover={{
                bg: 'teal.400',
              }}
              borderRadius={"5px"}
            >
              <Image
                src={skill.image}
                alt={skill.name}
                className="skills-card-img"
                boxSize="100px"
                objectFit="contain"
              />
              <Heading as='h4' size='sm' mt={2} className="skills-card-name">
                {skill.name}
              </Heading>
            </Box>
          ))}
        </Flex>
      </Box>
    </div>
  );
};

export default Skills;
